import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Nachdem anmelden soll iOS den User fragen, ob email+password gespeichert werden sollen.
// Android macht das bereits automatisch. Diese Bridge Component wird nur von iOS verwendet

// Connects to data-controller="native--credentials"
export default class extends BridgeComponent {
  static component = "credentials"
  static targets = ["email", "password"]

  save(event) {
    if (!event.detail.success) return

    this.send("save", { email: this.emailTarget.value, password: this.passwordTarget.value })
  }
}
